import script from "./HoldingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HoldingsModal.vue?vue&type=script&setup=true&lang=js"

import "./HoldingsModal.vue?vue&type=style&index=0&id=d7eee25e&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7eee25e"]])

export default __exports__